import { apiClient } from './apiClient';

export const subscriptionsService = {
  get: id => apiClient.get(`/api/subscriptions/${id}`),
  create: payload => apiClient.post('/api/subscriptions', payload),
  mine: () => apiClient.get('/api/subscriptions/my-subscription'),
};

export default subscriptionsService;
